import { Directive, ElementRef, inject } from "@angular/core";

/**
 * Directive that submits a form when the Ctrl + Enter keys are pressed, and blocks the default behavior of the Enter key.
 * The directive should be placed on the form element, and the form should have a submit button. For example of use, see LgBookmarkEditDialogComponent.
 */
@Directive({
    standalone: true,
    selector: "[lgSubmitOnCtrlEnter]",
    host: {
        "(keydown.enter)": "onEnter($event)",
        "(keydown.control.enter)": "onCtrlEnter($event)"
    }
})
export class LgSubmitOnCtrlEnterDirective {
    private _root = inject(ElementRef<HTMLElement>);

    onEnter(event: KeyboardEvent): void {
        event.stopPropagation();
        event.preventDefault();
    }

    onCtrlEnter(event: KeyboardEvent): void {
        event.stopPropagation();
        event.preventDefault();
        const submit = this._root.nativeElement.querySelector('button,input[type="submit"]') as
            | HTMLButtonElement
            | HTMLInputElement
            | null;

        if (!submit) {
            console.warn("No submit button found in form with lgSubmitOnCtrlEnter directive");
            return;
        }
        submit.click();
    }
}
